import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatPrice, formatDate } from "../../lib/api";
import { StatCard } from "../../components/shared";
import { Card } from "../../components/ui/card";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { ShoppingBag, Sparkles, Euro, Package, Truck, AlertTriangle } from "lucide-react";

export default function AdminDashboard() {
  const [d, setD] = useState(null);
  const navigate = useNavigate();
  useEffect(() => { api.get("/admin/dashboard").then(({ data }) => setD(data)); }, []);
  if (!d) return <p className="text-slate-400">Caricamento...</p>;

  return (
    <div>
      <h1 className="text-2xl sm:text-3xl font-extrabold font-display text-slate-900">Dashboard</h1>
      <div className="mt-6 grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard label="Ordini totali" value={d.orders_total} icon={ShoppingBag} accent="emerald" />
        <StatCard label="Ordini nuovi" value={d.orders_new} icon={Sparkles} accent="sky" />
        <StatCard label="Ordini pagati" value={d.orders_paid} icon={Euro} accent="violet" />
        <StatCard label="Fatturato" value={formatPrice(d.revenue)} icon={Euro} accent="emerald" />
        <StatCard label="In preparazione" value={d.orders_preparing} icon={Package} accent="amber" />
        <StatCard label="Spediti" value={d.orders_shipped} icon={Truck} accent="sky" />
        <StatCard label="Prodotti" value={d.products} icon={Package} accent="emerald" />
        <StatCard label="Non disponibili" value={d.products_unavailable} icon={AlertTriangle} accent="rose" />
      </div>

      <div className="mt-6 grid lg:grid-cols-2 gap-6">
        <Card className="p-6 rounded-2xl border-slate-200">
          <h3 className="font-display font-bold text-slate-900 mb-4">Ordini per stato</h3>
          {d.orders_by_status.length ? (
            <ResponsiveContainer width="100%" height={240}>
              <BarChart data={d.orders_by_status} margin={{ left: -20 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
                <XAxis dataKey="status" tick={{ fontSize: 10, fill: "#94a3b8" }} />
                <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: "#94a3b8" }} />
                <Tooltip contentStyle={{ borderRadius: 12, fontSize: 12 }} />
                <Bar dataKey="count" fill="#059669" radius={[8, 8, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          ) : <p className="text-sm text-slate-400 py-12 text-center">Nessun ordine ancora.</p>}
        </Card>

        <Card className="p-6 rounded-2xl border-slate-200">
          <h3 className="font-display font-bold text-slate-900 mb-4">Ordini recenti</h3>
          <div className="space-y-2">
            {d.recent_orders.map((o) => (
              <div key={o.id} className="flex justify-between items-center text-sm border-b border-slate-50 pb-2 cursor-pointer hover:text-primary" onClick={() => navigate(`/admin/ordini/${o.id}`)} data-testid={`dash-order-${o.id}`}>
                <div><span className="font-medium text-slate-800">{o.order_number}</span><span className="text-slate-400 ml-2">{o.customer.nome} {o.customer.cognome}</span></div>
                <div className="text-right"><span className="font-semibold">{formatPrice(o.total)}</span><div className="text-xs text-slate-400">{o.order_status}</div></div>
              </div>
            ))}
            {!d.recent_orders.length && <p className="text-sm text-slate-400">Nessun ordine.</p>}
          </div>
        </Card>
      </div>
    </div>
  );
}
